<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            style="height: 100%"
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="carInsBtn">
              <el-row>
                <el-col class="carInsHeadLeft" :span="12">
                  <span>{{
                    $t("JurisdictionalManagement.choseJurisdiction")
                  }}</span>
                </el-col>
                <el-col class="carInsHeadRight" :span="12">
                  <span>
                    <el-button type="text" @click="addCompany">{{
                      $t("common.btn.add")
                    }}</el-button>
                  </span>
                </el-col>
              </el-row>
            </div>
            <div class="carInsList">
              <el-scrollbar>
                <el-radio-group
                  @change="ChangCompany"
                  style="width: 100%"
                  v-model="CompanyId"
                >
                  <el-radio
                    v-for="item in companyList"
                    :key="item.id"
                    :label="item.id"
                    >{{ item.jurisdictionName }}</el-radio
                  >
                </el-radio-group>
              </el-scrollbar>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="carDisRight">
        <div class="carInsTitle">
          <el-scrollbar>
            <div class="carInsTitleTop">
              <div class="carInsTopBox" style="border: none">
                <div class="carInsTopLeft">
                  {{ $t("JurisdictionalManagement.jurisdictionInform") }}
                </div>
                <div class="carInsTopLeftRight">
                  <el-button size="small" type="text" @click="editCompany">{{
                    $t("common.btn.edit")
                  }}</el-button>
                  <el-button size="small" type="text" @click="deleteCompany">{{
                    $t("common.btn.delete")
                  }}</el-button>
                </div>
              </div>
              <div class="carDisNewsBox">
                <el-row :gutter="20">
                  <el-col :span="12" style="padding-right: 0">
                    <div class="boxPart">
                      <div class="carInsNews">
                        <p>
                          {{ $t("JurisdictionalManagement.jurisdictionName") }}
                        </p>
                        <el-input
                          v-model="companyDetail.jurisdictionName"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("JurisdictionalManagement.loginName") }}</p>
                        <el-input
                          v-model="companyDetail.loginName"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("JurisdictionalManagement.email") }}</p>
                        <el-input
                          v-model="companyDetail.email"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("CompanyManagement.createTime") }}</p>
                        <el-input
                          v-model="companyDetail.createTime"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNew">
                        <div class="newleft">
                          <p class="leftName">
                            {{ $t("CompanyManagement.logoPath") }}
                          </p>
                          <p class="leftRemark">
                            {{ $t("CompanyManagement.form.companyLogoTip") }}
                          </p>
                        </div>
                        <div style="display: flex">
                          <div
                            style="
                              width: 180px;
                              text-align: right;
                              padding-right: 20px;
                            "
                          ></div>
                          <div class="newRight">
                            <img :src="companyDetail.imgSrc" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="12" style="padding-left: 0">
                    <div class="boxPart">
                      <div class="carInsNews">
                        <p>
                          {{ $t("JurisdictionalManagement.jurisdictionNum") }}
                        </p>
                        <el-input
                          v-model="companyDetail.jurisdictionNum"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("JurisdictionalManagement.userName") }}</p>
                        <el-input
                          v-model="companyDetail.userName"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("common.lastUser") }}</p>
                        <el-input
                          v-model="companyDetail.lastUser"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("common.updateTime") }}</p>
                        <el-input
                          v-model="companyDetail.updateTime"
                          readonly
                          autocomplete="off"
                        ></el-input>
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("JurisdictionalManagement.editRole") }}</p>
                        <!-- <el-select
                          v-model="companyDetail.rolePower"
                          readonly
                        >
                          <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select> -->
                        <el-input
                          v-model="companyDetail.rolePowerName"
                          readonly
                          autocomplete="off"
                        ></el-input>
                        <!-- <el-button class="btn" @click="changeRole"
                            >{{$t('JurisdictionalManagement.editRole')}}</el-button
                          > -->
                      </div>
                      <div class="carInsNews">
                        <p>{{ $t("common.btn.resetPass") }}</p>
                        <el-button class="btn" @click="changePass">{{
                          $t("common.btn.resetPass")
                        }}</el-button>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        :title="$t('common.btn.resetPass')"
        :visible.sync="outerVisible"
        class="passDialog"
        :close-on-click-modal="false"
      >
        <div>{{ $t("JurisdictionalManagement.resetTip") }}</div>
        <el-dialog
          width="30%"
          :title="$t('common.btn.resetPassSuccess')"
          :visible.sync="innerVisible"
          append-to-body
          :close-on-click-modal="false"
        >
          <div>
            {{ $t("JurisdictionalManagement.resetPassword") }}{{ resetPass }}
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="innerVisible = false">{{
              $t("common.btn.confirm")
            }}</el-button>
          </div>
        </el-dialog>
        <div slot="footer" class="dialog-footer">
          <el-button @click="outerVisible = false">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button type="primary" @click="resetSubmit()">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="800px"
        :before-close="closeDia"
        class="carDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="jurisdictionNum"
            :label="$t('JurisdictionalManagement.jurisdictionNum') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.jurisdictionNum"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="jurisdictionName"
            :label="$t('JurisdictionalManagement.jurisdictionName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.jurisdictionName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="loginName"
            :label="$t('JurisdictionalManagement.loginName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.loginName"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item
            prop="userName"
            :label="$t('JurisdictionalManagement.userName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.userName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="email"
            :label="$t('JurisdictionalManagement.editRole') + ':'"
            :label-width="formLabelWidth"
          >
            <el-select
              v-model="form.rolePower"
              :placeholder="$t('common.choseTip')"
              filterable
            >
              <el-option
                v-for="item in roleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            prop="email"
            :label="$t('JurisdictionalManagement.email') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.email"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="logoPath"
            :label="$t('JurisdictionalManagement.logoPath') + ':'"
            :label-width="formLabelWidth"
            style="width: 340px"
          >
            <el-upload
              class="avatar-uploader"
              :action="processImg"
              :show-file-list="false"
              :file-list="FileList"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
            >
              <img v-if="imageUrl" :src="imageUrl" class="avatars" />
              <i v-else class="el-icon-plus avatars-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- <el-dialog
        width="820px"
        :before-close="closeRoleDia"
        class="addDialong"
        :title="$t('CompanyManagement.editAdmin')"
        v-if="dialogRoleFormVisible"
        :visible.sync="dialogRoleFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="RoleRules" ref="RoleForm" :model="RoleForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item
                prop="menu"
                :label="$t('CompanyManagement.form.menu') + ':'"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="data"
                    show-checkbox
                    node-key="id"
                    ref="tree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="checkKeys"
                    :default-checked-keys="checkKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="appMenu"
                :label="$t('CompanyManagement.form.appMenu') + ':'"
                :label-width="formLabelWidth"
              >
                <el-scrollbar>
                  <el-tree
                    :data="appData"
                    show-checkbox
                    node-key="id"
                    ref="appTree"
                    :expand-on-click-node="false"
                    :default-expanded-keys="appCheckKeys"
                    :default-checked-keys="appCheckKeys"
                    :props="defaultProps"
                  >
                  </el-tree>
                </el-scrollbar>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancleRoleForm('RoleForm')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button
            size="small"
            type="primary"
            @click="submitRoleForm('RoleForm')"
            >{{ $t("common.btn.confirm") }}</el-button
          >
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>

<script>
import JurisdictionalManagement from "./JurisdictionalManagement.js";
export default JurisdictionalManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
